import { Col, Row, Space, Upload } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import Button from 'components/Button';
import { ColumnsType } from 'antd/es/table';
import { Table } from 'antd/lib';
import { DownloadOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import useQueryParam from 'hooks/useQueryPrams';
import { useEffect, useState } from 'react';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { useQuery } from 'react-query';
import CartApi from 'apis/CartApi';
import * as XLSX from 'xlsx';
import { openNotificationWithIcon } from 'utils/notification';
import formatCurrencyVND from 'utils/formatCurrencyVND';

type FixedType = 'left' | 'right' | boolean;

interface IProps {
  cart?: any;
}

export default function PreOrderProduct(props: IProps): JSX.Element {
  const { cart } = props;
  const history = useHistory();
  const queryParam = useQueryParam();

  const [page, setPage] = useState(parseInt(queryParam.get('page') + '') || 1);
  const [page_size, setPage_size] = useState<number>(
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE
  );
  const [productList, setProductList] = useState<any>();
  const [excelDownloadList, setExcelDownloadList] = useState<any>();
  const [total, setTotal] = useState<number>();

  useEffect(() => {
    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
  }, [page, page_size]);

  const params = {
    cart_code: cart?.cart_code,
    page: page,
    page_size: page_size,
  };

  const { isLoading: getCartByCartCodeLoading } = useQuery(
    ['getCartByCartCode', params],
    () =>
      CartApi.getProductOfCartChiNhanh(params)
        .then((res) => {
          setProductList(res?.data);
          setTotal(res?.total);
        })
        .catch((err) => {
          console.log(err);
        })
  );

  const { isLoading: downloadExcelLoading } = useQuery(
    ['getListProductToDownload'],
    () =>
      CartApi.getProductOfCartChiNhanh({
        cart_code: cart?.cart_code,
        page: 1,
        page_size: total,
      })
        .then((res) => {
          setExcelDownloadList(res?.data);
        })
        .catch((err) => {
          console.log(err);
        })
  );

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 80,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã mẫu',
      dataIndex: 'ma_mau',
      width: 220,
    },
    {
      title: 'Tên mẫu',
      dataIndex: 'ten_mau',
      width: 300,
    },
    {
      title: 'Hình ảnh',
      dataIndex: 'image_default',
      width: 120,
      render: (_: any, record: any) => {
        return (
          <img
            style={{ width: 60, height: 60 }}
            src={record?.image_default}
            alt=""
          />
        );
      },
    },
    {
      title: 'Bộ phận phát triển',
      dataIndex: 'nhan_hang',
      width: 180,
    },
    {
      title: 'Dòng hàng Xman',
      dataIndex: 'xman',
      width: 180,
    },
    {
      title: 'Chủng loại',
      dataIndex: 'chung_loai',
      width: 150,
    },
    {
      title: 'Kết luận đánh giá 3 tiêu chí',
      dataIndex: 'kldg_3tc',
      width: 250,
    },
    {
      title: 'Doanh thu 6 tháng gần nhất',
      dataIndex: 'doanhthu_6th',
      width: 250,
    },
    {
      title: 'Tổng SL Tồn hiện tại',
      dataIndex: 'tongsl_ton',
      width: 200,
    },
    {
      title: 'Tổng giá trị Tồn hiện tại',
      dataIndex: 'tong_giatri',
      width: 200,
      // render: (text, record, index) => formatCurrencyVND(text),
    },
    {
      title: 'Giá trung bình',
      dataIndex: 'price',
      width: 180,
      render: (text, record, index) => formatCurrencyVND(text),
    },
    {
      title: 'Vốn tồn phân bổ',
      width: 180,
    },
    {
      title: 'Mã cửa hàng',
      dataIndex: 'cua_hang',
      width: 180,
    },
    {
      title: 'Số lượng phần bổ',
      width: 180,
    },
    {
      title: '',
      fixed: 'right' as FixedType,
      width: 50,
      // render: (record: any) => (
      //   <div className="flex justify-around">
      //     <button
      //       onClick={() => {
      //         history.push(`/department-approval/detail/${record.id}`);
      //       }}
      //     >
      //       <EyeIcon />
      //     </button>
      //   </div>
      // ),
    },
  ];

  const generateExcel = () => {
    const data = [];
    if (excelDownloadList.length == 0) {
      openNotificationWithIcon(
        'error',
        'Không thể tải file Excel',
        'Không có sản phẩm'
      );
    } else {
      const headerRow = columns.map((column) => {
        return column.title;
      });
      data.push(headerRow);

      excelDownloadList.forEach((product: any, key: number) => {
        const rowData = columns.map((column) => {
          if (column.dataIndex === 'id') {
            return key + 1;
          }
          if (column.dataIndex === 'price') {
            return formatCurrencyVND(product[column.dataIndex]);
          }
          // if (column.dataIndex === 'tong_giatri') {
          //   return formatCurrencyVND(product[column.dataIndex]);
          // }

          return product[column.dataIndex];
        });

        data.push(rowData);
      });

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `danh_sach_san_pham.xlsx`);
    }
  };

  return (
    <>
      <div className="mb-4 flex flex-col gap-4 pb-20 border-b-2 border-[#E1E3E6]">
        <Content>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="space-between"
            align="middle"
            className="mb-3"
          >
            <Col span={12}>
              <div className="text-xl font-bold">
                Danh sách sản phẩm thuộc giỏ hàng
              </div>
            </Col>
            <Col span={12}>
              <Row justify="end" align="middle">
                <Space>
                  <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border={'border-primary-50'}
                    customClass="fix-border-radius"
                    onClick={() => {
                      generateExcel();
                    }}
                  >
                    <DownloadOutlined />
                    Tải file excel
                  </Button>
                </Space>
              </Row>
            </Col>
          </Row>
          <Table
            rowKey={(record) => record.id}
            columns={columns}
            scroll={{ x: 958 }}
            className="customTable"
            dataSource={productList}
            loading={getCartByCartCodeLoading || downloadExcelLoading}
            // rowSelection={rowSelection}
            pagination={{
              className: 'flex items-center',
              current: page,
              pageSize: page_size,
              total: total,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],
              onChange: (page: number, pageSize: number) => {
                setPage(page);
                setPage_size(pageSize);

                history.push('/preorder/edit', {
                  cart: cart,
                  page: page,
                  page_size: pageSize,
                });
              },
            }}
          />
        </Content>
      </div>
    </>
  );
}
